import './style.scss';

import React from 'react';

import Name from './Name';
import SocialLinks from './SocialLinks';

const Landing = () => (
  <div className="banner">
    <div className="bannerContent">
      <Name />
      <SocialLinks />
    </div>
  </div>
);

export default Landing;
